import { render, staticRenderFns } from "./UserTaskConfig.vue?vue&type=template&id=6d78afa8&scoped=true"
import script from "./UserTaskConfig.vue?vue&type=script&lang=js"
export * from "./UserTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./UserTaskConfig.vue?vue&type=style&index=0&id=6d78afa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78afa8",
  null
  
)

export default component.exports